var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-container sn-container"},[_c('div',{staticClass:"sn-content"},[_c('div',{staticClass:"sn-title"},[_vm._v("滚动弧形线")]),_c('div',{staticClass:"sn-body"},[_c('div',{staticClass:"wrap-container"},[_c('div',{staticClass:"chartsdom",attrs:{"id":"chart_arc"}})])])])])
}]

export { render, staticRenderFns }